import styled from '@emotion/styled';

export const Zoom = styled.div`
  background-color: white;
  transition: transform 0.2s;
  ${({ selected }) => selected && 'z-index: 1'};

  &:hover {
    transform: scale(5.66);
  }
`;
